import CitySEOHead from "@/components/feature/CitySEOHead";
import GeorgiaHeroSection from "./components/HeroSection";
import GeorgiaCommunitiesWeServe from "./components/CommunitiesWeServe";
import GeorgiaCitiesDirectory from "./components/CitiesDirectory";
import GeorgiaStateResources from "./components/StateResources";
import GeorgiaFAQSection, { faqs as rawFaqs } from "./components/FAQSection";
import GeorgiaFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const faqs = rawFaqs.map((f: { question: string; answer: string }) => ({ q: f.question, a: f.answer }));

const servicesSchema = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function GeorgiaPage() {
  return (
    <>
      <CitySEOHead
        city="Georgia"
        state="Georgia"
        stateAbbr="GA"
        route="/states/georgia"
        title="Georgia Passport Services — Expedited & Emergency | Fast Passport Center"
        description="Expedited passport services across Georgia — Atlanta, Savannah, Augusta, Macon, Athens. Emergency processing as fast as 24 hours. A+ BBB rated courier service."
        geoPlacename="Georgia, United States"
        geoPosition="32.1656;-82.9001"
        faqs={faqs}
        servicesSchema={servicesSchema}
      />
      <div className="font-sans">
        <GeorgiaHeroSection />
        <GeorgiaCommunitiesWeServe />
        <GeorgiaCitiesDirectory />
        <GeorgiaStateResources />
        <GeorgiaFAQSection />
        <SEOCrossLinks state="GA" />
        <GeorgiaFinalCTA />
      </div>
    </>
  );
}